import {Grid} from '@mui/material';
import CustomTextField from './TextField';

const RequiredFields = (props) => {
  return (
    <>
      <Grid item xs={12}>
        <CustomTextField
          {...props}
          name='firstName'
          label={'نام'}
          type='text'
          maxLength={30}
        />
      </Grid>
      <Grid item xs={12}>
        <CustomTextField
          {...props}
          name='lastName'
          label={'نام خانوادگی'}
          type='text'
          maxLength={30}
        />
      </Grid>
      <Grid item xs={12}>
        <CustomTextField
          {...props}
          name='phoneNumber'
          label='شماره تماس'
          type='number'
          disabled={props.type === 'edit'}
        />
      </Grid>
    </>
  );
};

export default RequiredFields;
